<template>
  <div class="container py-6">
    <div class="custom-logo">
      <img src="https://invoicesainet.blob.core.windows.net/images/J_Logo_Black_256x256.png" alt="App" width="64" />
      <div>Agreement and Terms of Service</div>
    </div>

    <p><strong>Effective Date:</strong> January 1, 2025</p>

    <p>
      By using the Invoices AI website or service operated by Jingle Enterprises ("Service"), you agree to be bound by the following terms and
      conditions ("Terms of Service"). Jingle Enterprises reserves the right to update and change these Terms at any time without notice. Continued
      use of the Service after any such changes constitutes your acceptance of the new terms.
    </p>
    <p>Violation of any of these terms may result in the suspension or termination of your account.</p>

    <h5>1. Account Terms</h5>
    <ul>
      <li>You are responsible for maintaining the confidentiality and security of your account credentials.</li>
      <li>You are responsible for all activity and content submitted through your account.</li>
      <li>You agree not to use the Service for any unlawful or unauthorized purpose or in violation of any applicable laws.</li>
      <li>Jingle Enterprises reserves the right to suspend or terminate accounts found to be in violation of these terms at its sole discretion.</li>
    </ul>

    <h5>2. Subscription and Transaction Fees</h5>
    <ul>
      <li>
        Access to the Service requires an active subscription. Subscriptions are available on a monthly basis ($20/month) or annually ($200/year).
      </li>
      <li>
        In addition to subscription fees, your use of the Service may incur <strong>transaction-based charges</strong> as outlined on our
        <b>Pricing page</b>.
      </li>
      <li>
        Transaction fees are tiered and based on usage volume (i.e. number of invoices processed) or may follow an alternative pricing model (Fixed or
        License-based) if agreed upon.
      </li>
      <li>All fees are non-refundable and are billed in advance.</li>
      <li>No prorated refunds or credits will be issued for partial months or unused services.</li>
      <li>All fees exclude any applicable taxes or duties, which are your responsibility to pay.</li>
    </ul>

    <h5>3. Modifications to the Service and Pricing</h5>
    <ul>
      <li>
        Jingle Enterprises reserves the right to modify or discontinue the Service (or any part of it), temporarily or permanently, with or without
        notice.
      </li>
      <li>
        Pricing for both subscriptions and transactions is subject to change with 30 days’ notice. Changes will be communicated via the Service
        website or email.
      </li>
      <li>Jingle Enterprises will not be liable for any modification, price change, suspension, or discontinuation of the Service.</li>
    </ul>

    <h5>4. Intellectual Property</h5>
    <p>
      Jingle Enterprises (or its licensors) retains all rights, title, and interest in the Service, including software, branding, interface elements,
      and documentation.
    </p>
    <p>You may not reverse engineer, copy, distribute, or create derivative works of the Service without explicit written permission.</p>
    <p>
      Content uploaded or submitted by you remains your intellectual property. By submitting content, you grant Jingle Enterprises permission to use,
      process, and display the content as necessary to provide the Service.
    </p>

    <h5>5. Communications & Notifications</h5>
    <p>
      By registering for the Service, you consent to receive email communications related to your account and use of the platform. Jingle Enterprises
      will never sell or share your email address with third parties.
    </p>

    <h5>6. Acceptable Use and Conduct</h5>
    <ul>
      <li>Do not upload, post, or transmit content that is unlawful, harmful, offensive, or violates intellectual property rights.</li>
      <li>Do not use the Service to distribute unsolicited emails or spam.</li>
      <li>Do not transmit any viruses, worms, or malicious code.</li>
      <li>Do not attempt unauthorized access to any portion of the Service or related systems.</li>
    </ul>

    <h5>7. Disclaimers and Limitations of Liability</h5>
    <p>
      The Service is provided “as is” and “as available” without warranty of any kind. Jingle Enterprises does not guarantee the Service will be
      uninterrupted, secure, or error-free.
    </p>
    <p>
      In no event shall Jingle Enterprises be liable for any indirect, incidental, special, or consequential damages, including loss of data or
      profits, arising from your use of the Service.
    </p>

    <h5>8. General Provisions</h5>
    <p>
      These Terms constitute the entire agreement between you and Jingle Enterprises regarding your use of the Service. Failure to enforce any
      provision of these Terms does not constitute a waiver of such provision.
    </p>

    <h4>Contact Us</h4>
    <p>
      Jingle Enterprises
      <a href="https://jingleenterprises.com" target="_blank" class="ms-1">(https://jingleenterprises.com)</a>
      <br />
      Email: <a href="mailto:info@jingleenterprises.com">info@jingleenterprises.com</a>
      <br />
      Support: <a href="mailto:info@jingleenterprises.com">support@jingleenterprises.com</a>
    </p>
  </div>
</template>
<style lang="scss" scoped>
.custom-logo {
  width: 100%;
  margin-bottom: 20px;
  display: inline-flex;
  div {
    margin-left: 20px;
    font-size: 2.5rem;
    color: #000;
  }
}
</style>
